class SmoothScroll {
	constructor() {
		window.smoothy = ScrollSmoother.create({
			smooth: 0.78,               // how long (in seconds) it takes to "catch up" to the native scroll position
			effects: true,           // looks for data-speed and data-lag attributes on elements
			// normalizeScroll: true,   // prevents showing/hiding of address bar, works around iOS Safari jitter, etc.
			// smoothTouch: 0.1 ,       // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
			// ignoreMobileResize: true // skips ScrollTrigger.refresh() on mobile resizes from address bar showing/hiding
		});
	}
}
